var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.311523 0H11.465C12.2179 0 13.3286 0.212393 14.2813 0.881805C15.2861 1.58786 16.0512 2.76371 16.0512 4.5V21.135L9.04839 15.2994L1.99941 21.1234V4.5C1.99941 3.21796 1.99773 2.54089 1.9496 2.11137C1.91286 1.7836 1.8648 1.73116 1.81598 1.6779C1.81285 1.67448 1.80971 1.67105 1.80656 1.66754L0.311523 0ZM3.94852 2C3.99948 2.54969 3.99945 3.31666 3.99941 4.40891C3.99941 4.43903 3.99941 4.46939 3.99941 4.5V16.8766L9.05387 12.7006L14.0512 16.865V4.5C14.0512 3.4363 13.6209 2.86214 13.1314 2.5182C12.5898 2.13761 11.9075 2 11.465 2H3.94852Z",
    fill: "#728997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.74f684fc6cab95b9d7a9b8d1ffb0630d.svg";
export { ForwardRef as ReactComponent };